import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--archive"
export default class extends Controller {
  static targets = ["selectedCameras", "pause", "camera"]
  static values = {
    id: String, name: String
  }

  connect() {
    document.addEventListener('selectedCameras:camera', (e) => {
      let checkedInputs = this.selectedCamerasTarget.querySelectorAll('input:checked')
      const cameraIds = Array.from(checkedInputs).map(input => input.dataset.cameraId).filter(id => id !== undefined);
      e.detail.callback({
        cameraIds: cameraIds
      })
    })
    let params = new URLSearchParams(document.location.search);
    let cameraIds = params.get("cameraIds")
    if (cameraIds) {
      setTimeout(() => {

        for (const camera of this.cameraTargets) {
          let id = camera.dataset.cameraId
          if (cameraIds.split(',').includes(id)) {
            camera.click();
          }
        }
      }, 200);
    }

  }

  triggeredPause() {
    document.dispatchEvent(new CustomEvent("video-pause", {
      bubbles: true
    }))
  }

  triggeredPlay() {
    document.dispatchEvent(new CustomEvent("video-play", {
      bubbles: true
    }))
  }


  async play(event) {
    event.preventDefault();

    let data = {}

    let checked = this.selectedCamerasTarget.querySelectorAll('input:checked');

    if (checked.length > 0) {

      document.dispatchEvent(new CustomEvent("archive:play", {
        bubbles: true, detail: {callback: (state) => data = state}
      }))
      document.dispatchEvent(new CustomEvent("play-archive", {
        detail: {
          min: data.min, max: data.max
        }
      }))
    } else {
      alert('Please select camera')
    }


  }

  disconnect() {
    document.removeEventListener('selectedCameras:camera', (e) => {
      let checkedInputs = this.selectedCamerasTarget.querySelectorAll('input:checked')
      const cameraIds = Array.from(checkedInputs).map(input => input.dataset.cameraId).filter(id => id !== undefined);
      e.detail.callback({
        cameraIds: cameraIds
      })
    })
    super.disconnect();
  }
}




